// Basic
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modules
import { MaterialModule } from '@app/material.module';

// Components
import { SelectorPeopleMenuComponent } from './selector-people-menu.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule
  ],
  declarations: [SelectorPeopleMenuComponent],
  exports: [SelectorPeopleMenuComponent],
  entryComponents: [SelectorPeopleMenuComponent]
})

export class SelectorPeopleMenuModule { }
